import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { REQUIRED_FILTER_TYPES } from '@reports/utils/dashboard/constants';
import { CloseIcon } from '@common/components/icons';
import * as styles from './FilterMultiSelect.module.css';

/**
 * FilterMultiSelect Component
 * Displays available filters as buttons and selected filters as chips
 * Matches Figma design
 */
function FilterMultiSelect({ requiredFilters, onChange }) {
  const { t } = useTranslation();

  const handleFilterToggle = (filterKey) => {
    if (requiredFilters.includes(filterKey)) {
      // Remove filter
      onChange(requiredFilters.filter((key) => key !== filterKey));
    } else {
      // Add filter
      onChange([...requiredFilters, filterKey]);
    }
  };

  const handleRemoveFilter = (filterKey) => {
    onChange(requiredFilters.filter((key) => key !== filterKey));
  };

  return (
    <div className={styles.container}>
      {/* Available Filters Section */}
      <div className={styles.availableFiltersSection}>
        <p className={styles.label}>{t('dashboard.requiredFilters.availableFilters')}</p>
        <div className={styles.filtersRow}>
          {REQUIRED_FILTER_TYPES.map((filterKey) => {
            const isSelected = requiredFilters.includes(filterKey);
            return (
              <button
                key={filterKey}
                type="button"
                className={`${styles.filterButton} ${isSelected ? styles.filterButtonSelected : ''}`}
                onClick={() => handleFilterToggle(filterKey)}
              >
                {t(`dashboard.requiredFilters.filters.${filterKey}`)}
              </button>
            );
          })}
        </div>
      </div>

      {/* Selected Filters Section */}
      <div className={styles.selectedFiltersSection}>
        <p className={styles.label}>{t('dashboard.requiredFilters.selectedFilters')}</p>
        <div className={styles.selectedFiltersContainer}>
          {requiredFilters.length === 0 ? (
            <p className={styles.emptyState}>{t('dashboard.requiredFilters.noFiltersSelected')}</p>
          ) : (
            <div className={styles.selectedFiltersRow}>
              {requiredFilters.map((filterKey) => (
                <div key={filterKey} className={styles.selectedFilterChip}>
                  <span className={styles.chipText}>
                    {t(`dashboard.requiredFilters.filters.${filterKey}`)}
                  </span>
                  <button
                    type="button"
                    className={styles.chipRemoveButton}
                    onClick={() => handleRemoveFilter(filterKey)}
                    aria-label={t('common.remove')}
                  >
                    <CloseIcon className={styles.chipRemoveIcon} />
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

FilterMultiSelect.propTypes = {
  requiredFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default FilterMultiSelect;




